/** Identities the signed-in Clerk account owns, as reported by `api.users.currentAccountAccess`. */
export type AccountAccess = {
  hasProviderProfile: boolean
  hasGuestProfile: boolean
}

export const GUEST_CLERK_ROLE = 'guest'

/** Clerk `unsafeMetadata.role` set during booking magic-link sign-up. */
export function readClerkAccountRole(unsafeMetadata: unknown): string | null {
  if (typeof unsafeMetadata !== 'object' || unsafeMetadata === null) {
    return null
  }
  const role = (unsafeMetadata as { role?: unknown }).role
  return typeof role === 'string' ? role : null
}

/**
 * Booking-only account: it may run the booking flow but never the provider app.
 * The Convex `profiles` row is the source of truth; the Clerk role only covers
 * guests who signed up but have not submitted a booking yet.
 */
export function isGuestOnlyAccount(access: AccountAccess, clerkRole: string | null): boolean {
  if (access.hasProviderProfile) {
    return false
  }
  return access.hasGuestProfile || clerkRole === GUEST_CLERK_ROLE
}
